import { Card, Col, Grid, Row, Typography } from "antd";
import CustomButton from "../share/customButton";
import HintInput from "../share/hintInput";
import InputWithIcons from "../share/InputWithIcons";
import CustomLabel from "../share/customLabel";
import { ColorPalette } from "../share/color/colorPalette";
import logo from "../../assets/logo.jpg";
import star from "../../assets/vectors/Star.svg";
import { useEffect, useState } from "react";
import {
  ChangePasswordApi,
  CheckConfirm,
  SignIn,
} from "../../services/AccountService";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchUserProfile } from "../../features/profile/profileSlice";
import { fetchUserPosition } from "../../features/position/positionSlice";
import {
  ArrowRightOutlined,
  EditOutlined,
  LeftOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import TedIcon from "../share/TedIcon";
import TedTitle from "../share/TedTitle";
import TedOTP from "../share/TedOTP";
import { SendConfirmationCode } from "../../services/CommiunicationService";
const { useBreakpoint } = Grid;
const LoginV2 = () => {
  const screens = useBreakpoint();
  const [getPhoneNumber, setPhoneNumber] = useState("");
  const [getPassword, setPassword] = useState("");
  const [getPhoneNumberIsNotEmpty, setPhoneNumberIsNotEmpty] = useState(true);
  const [getPhoneNumberIsValid, setPhoneNumberIsValid] = useState(true);
  const [getPasswordIsValid, setPasswordIsValid] = useState(true);

  const dispatch = useDispatch<any>();
  const profileStatus = useSelector((state) => (state as any).profiles.status);
  const navigate = useNavigate();

  const convertToPersianDigits = (input: string) => {
    const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
    return input.replace(/[0-9]/g, (digit) => persianDigits[parseInt(digit)]);
  };

  const [state, setState] = useState(0);
  const [getPassword4get, setPassword4get] = useState("");
  const [getRepeatPassword, setRepeatPassword] = useState("");

  //Stage 2  start

  //# Timer Start
  const [seconds, setSeconds] = useState(180); // 3 minutes in seconds
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isActive && seconds > 0) {
      interval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [isActive, seconds]);

  const toggleTimer = () => {
    setIsActive((prev) => !prev);
  };

  const resetTimer = () => {
    setSeconds(180); // Reset to 3 minutes
    setIsActive(false);
  };

  // Format seconds into minutes and seconds
  const formattedTime = `${Math.floor(seconds / 60)
    .toString()
    .padStart(2, "0")}:${(seconds % 60).toString().padStart(2, "0")}`;
  //# Timer End

  const [otp, setOtp] = useState("");
  const handleOtpChange = (newOtp: string) => {
    setOtp(newOtp);
  };
  //Stage 2 End

  const loginUser = () => {
    try {
      SignIn(getPhoneNumber, getPassword).then(
        (p) => {
          // console.log(p);
          if (p.status === 200) {
            if (p.data.statusCode === 201) {
              localStorage.setItem("token", p.data.data.token);
              if (profileStatus === "idle") {
                dispatch(fetchUserProfile());
                dispatch(fetchUserPosition());
              }
              navigate("/");
            } else {
              //console.log(p.data.message);
              setPasswordIsValid(false);
            }
          }
        }
        // console.log(p.data.response.message)
      );
    } catch (error: any) {
      if (error.response.data) {
        Object.keys(error.response.data).forEach(async (key) => {
          // await show(error.response.data[key], 3);
        });
      }
    }
  };

  const sendForgetCode = () => {
    const data = SendConfirmationCode({
      phoneNumber: getPhoneNumber,
      isVerification: true,
    }).then(function (response: any) {
      if (response.data.statusCode === 400) {
        // console.log(response.data.message);
      } else {
        setState(1);
        toggleTimer();
      }
    });
  };

  const CheckConfirmAsync = async () => {
    try {
      await CheckConfirm(getPhoneNumber, otp, "0").then((p) => {
        if (p.status === 200) {
          localStorage.setItem("token", p.data.data.token);
          dispatch(fetchUserProfile()).then(() => {
            setState(2);
            // console.log("S2");
          });
        }
      });
    } catch (error) {
      // console.log((error as any).response.data);
    }
  };
  return (
    <>
      {!screens.xs ? (
        <Row className="main-row" style={{ height: "100vh" }}>
          <Col className="input-wizard-container" style={{ width: "50%" }}>
            <Col
              className="input-wizard"
              style={{
                width: "708px",
                height: "1024px",
                backgroundColor: ColorPalette.primaryBlue[600],
              }}
            >
              <img src={star} height={"1024px"} />
            </Col>
          </Col>
          <Col className="input-wizard-container" style={{ width: "50%" }}>
            <Col
              style={{
                width: "560px",
                height: "610px",
                display: state === 0 ? "block" : "none",
              }}
            >
              <Row>
                <img
                  style={{
                    margin: "auto",
                    width: "187px",
                    height: "102px",
                  }}
                  src={logo}
                />
              </Row>
              <Row
                style={{
                  marginTop: "32px",
                  height: "42px",
                }}
              >
                <div
                  style={{
                    all: "initial",
                    backgroundColor: "transparent",
                    display: "block",
                    width: "100%",
                  }}
                >
                  <div
                    className="iran text-divider"
                    style={{
                      color: ColorPalette.gray[950],
                      backgroundColor: "transparent",
                      fontSize: 16,
                      margin: "auto",
                      height: "42px",
                    }}
                  >
                    &nbsp; &nbsp;
                    {" هنوز ثبت نام نکرده اید ؟ "}
                    &nbsp; &nbsp;
                  </div>
                </div>
              </Row>
              <Row
                className="iran"
                style={{
                  height: "42px",
                  textAlign: "center",
                }}
              >
                <CustomButton
                  onClick={() => navigate("/Register")}
                  style={{ width: "100%" }}
                  type="link"
                  size="large"
                  hasTitle={true}
                >
                  عضویت در پلتفرم{" "}
                </CustomButton>
              </Row>
              <Row
                style={{
                  height: "42px",
                  textAlign: "center",
                  marginTop: "29.5px",
                }}
              >
                <Typography.Text
                  className="iran"
                  style={{ fontSize: "40px", fontWeight: 600 }}
                >
                  ورود
                </Typography.Text>
              </Row>
              <Row style={{ marginTop: "32px" }}>
                <CustomLabel customSize="Large">
                  لطفا شماره موبایل خود را وارد کنید
                </CustomLabel>
              </Row>
              <Row style={{ fontFamily: "YekanBakhVF" }}>
                <InputWithIcons
                  size="large"
                  value={getPhoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </Row>
              <Row style={{ marginTop: "12px" }}>
                <div
                  style={{
                    display: getPhoneNumberIsNotEmpty ? "none" : "block",
                  }}
                >
                  <HintInput customSize="Large" status="Error">
                    لطفا این قسمت را خالی نگذارید
                  </HintInput>
                </div>
                <div
                  style={{
                    display: getPhoneNumberIsValid ? "none" : "block",
                  }}
                >
                  <HintInput customSize="Large" status="Error">
                    شماره موبایل نادرست است
                  </HintInput>
                </div>
              </Row>
              <Row style={{ marginTop: "24px" }}>
                <CustomLabel customSize="Large">
                  لطفا رمز عبور خود را وارد کنید{" "}
                </CustomLabel>
              </Row>
              <Row style={{ fontFamily: "YekanBakhVF" }}>
                <InputWithIcons
                  size="large"
                  type="password"
                  value={getPassword}
                  onKeyPress={(e: any) => {
                    if (e.key === "Enter") {
                      loginUser();
                    }
                  }}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Row>
              <Row style={{ marginTop: "12px" }}>
                <div
                  style={{
                    display: getPasswordIsValid ? "none" : "block",
                  }}
                >
                  <HintInput customSize="Large" status="Error">
                    رمز عبور نادرست است
                  </HintInput>
                </div>
              </Row>
              <Row style={{ marginTop: "36px" }}>
                <CustomButton
                  onClick={() => {
                    loginUser();
                  }}
                  disabled={false}
                  customSize="Large"
                  type="primary"
                  hasTitle={true}
                  style={{ width: "100%" }}
                >
                  تایید
                </CustomButton>
              </Row>
              <Row
                className="iran"
                style={{
                  marginTop: "21.5px",
                  height: "40px",
                  textAlign: "center",
                }}
              >
                <CustomButton
                  style={{ width: "100%" }}
                  type="link"
                  size="large"
                  hasTitle={true}
                  onClick={() => sendForgetCode()}
                >
                  فراموشی رمز عبور{" "}
                </CustomButton>
              </Row>
            </Col>

            <Col
              style={{
                width: "560px",
                height: "610px",
                display: state === 1 ? "block" : "none",
              }}
            >
              <Row>
                <img
                  style={{
                    margin: "auto",
                    width: "187px",
                    height: "102px",
                  }}
                  src={logo}
                />
              </Row>
              <Row
                style={{
                  marginTop: "32px",
                  height: "42px",
                }}
              >
                <div onClick={() => setState(0)}>
                  <TedIcon Icon={ArrowRightOutlined} />
                </div>
                <TedTitle text="ارسال کد" />
              </Row>
              <Row
                style={{
                  marginTop: "32px",
                  height: "77px",
                  gap: "4px",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    textAlign: "center",
                    width: "100%",
                  }}
                >
                  <CustomLabel customSize="Large">
                    لطفا کد ارسال شده به شماره موبایل{" "}
                    {convertToPersianDigits(getPhoneNumber)} را وارد کنید
                  </CustomLabel>
                  <CustomButton
                    style={{ backgroundColor: "transparent" }}
                    RightIconEnabled
                    hasTitle
                    RightIcon={EditOutlined}
                    customType="Link"
                    customSize="Large"
                    onClick={() => setState(0)}
                  >
                    ویرایش شماره
                  </CustomButton>
                </div>
              </Row>
              <Row
                style={{
                  marginTop: "24px",
                  height: "64px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <TedOTP length={5} onChange={handleOtpChange} />
                </div>
              </Row>
              <Row
                style={{
                  marginTop: "24px",
                }}
              >
                <div style={{ width: "100%", textAlign: "center" }}>
                  <CustomButton
                    LeftIconEnabled
                    LeftIcon={LoadingOutlined}
                    hasTitle
                    customType="Text"
                  >
                    ارسال مجدد کد تا {formattedTime}
                  </CustomButton>
                </div>
              </Row>
              <Row
                style={{
                  marginTop: "48px",
                }}
              >
                <CustomButton
                  onClick={() => {
                    CheckConfirmAsync();
                  }}
                  customSize="Large"
                  type="primary"
                  hasTitle={true}
                  disabled={otp.length !== 5}
                  style={{ width: "100%" }}
                >
                  تایید
                </CustomButton>
              </Row>
            </Col>
            <Col
              style={{
                width: "560px",
                height: "610px",
                display: state === 2 ? "block" : "none",
              }}
            >
              <Row>
                <img
                  style={{
                    margin: "auto",
                    width: "187px",
                    height: "102px",
                  }}
                  src={logo}
                />
              </Row>
              <Row
                style={{
                  marginTop: "32px",
                  height: "42px",
                }}
              >
                <TedTitle text="وارد کردن رمز جدید" />
              </Row>

              <Row style={{ marginTop: "32px" }}>
                <CustomLabel customSize="Large">
                  {" "}
                  لطفا رمز عبور جدید را وارد کنید{" "}
                </CustomLabel>
              </Row>
              <Row style={{ fontFamily: "YekanBakhVF" }}>
                <InputWithIcons
                  LeftIconEnabled={true}
                  LeftIcon={LeftOutlined}
                  size="large"
                  value={getPassword4get}
                  onChange={(e) => {
                    setPassword4get(e.target.value);
                  }}
                />
              </Row>
              <Row style={{ marginTop: "12px" }}>
                <div
                  style={{
                    display: false ? "block" : "none",
                  }}
                >
                  <HintInput customSize="Large" status="Error">
                    لطفا این قسمت را خالی نگذارید
                  </HintInput>
                </div>
              </Row>

              <Row style={{ marginTop: "24px" }}>
                <CustomLabel customSize="Large">
                  لطفا رمز عبور را مجددا وارد کنید
                </CustomLabel>
              </Row>
              <Row style={{ fontFamily: "YekanBakhVF" }}>
                <InputWithIcons
                  LeftIconEnabled={true}
                  LeftIcon={LeftOutlined}
                  size="large"
                  value={getRepeatPassword}
                  onChange={(e) => {
                    setRepeatPassword(e.target.value);
                  }}
                />
              </Row>
              <Row style={{ marginTop: "12px" }}>
                <div
                  style={{
                    display: false ? "block" : "none",
                  }}
                >
                  <HintInput customSize="Large" status="Error">
                    لطفا این قسمت را خالی نگذارید
                  </HintInput>
                </div>
              </Row>

              <Row style={{ marginTop: "12px" }}>
                <div
                  style={{
                    display: false ? "block" : "none",
                  }}
                >
                  <HintInput customSize="Large" status="Error">
                    رمز عبور و تکرار آن باهم تطبیق ندارند
                  </HintInput>
                </div>
              </Row>
              <Row style={{ marginTop: "36px" }}>
                <CustomButton
                  onClick={() => {
                    ChangePasswordApi({
                      currentPassword: "",
                      phoneNumber: getPhoneNumber,
                      password: getPassword4get,
                      passwordConfirm: getRepeatPassword,
                    }).then(() => navigate("/"));
                  }}
                  disabled={false}
                  customSize="Large"
                  type="primary"
                  hasTitle={true}
                  style={{ width: "100%" }}
                >
                  تایید
                </CustomButton>
              </Row>
            </Col>
          </Col>
        </Row>
      ) : (
        <>
          <Row>
            <Col
              style={{
                height: "100%",
                width: "100%",
              }}
            >
              <Col
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "350px",
                  zIndex: -1,
                  backgroundColor: ColorPalette.primaryBlue[600],
                }}
              >
                <img src={star} height={"50%"} />
              </Col>
              <Col style={{ display: state === 0 ? "block" : "none" }}>
                <Row
                  style={{
                    marginTop: "32px",
                    height: "42px",
                  }}
                >
                  <div
                    style={{
                      margin: "auto",
                      backgroundColor: "transparent",
                      display: "block",
                      width: "345px",
                    }}
                  >
                    <div
                      className="iran text-divider"
                      style={{
                        color: "white",
                        backgroundColor: "transparent",
                        fontSize: 16,
                        margin: "auto",
                        height: "42px",
                      }}
                    >
                      &nbsp; &nbsp;
                      {" هنوز ثبت نام نکرده اید ؟ "}
                      &nbsp; &nbsp;
                    </div>
                  </div>
                </Row>
                <Row
                  className="iran"
                  style={{
                    marginTop: "8px",
                    textAlign: "center",
                  }}
                >
                  <CustomButton
                    style={{
                      margin: "auto",
                      backgroundColor: ColorPalette.gray[950],
                      width: "319px",
                      borderRadius: "4px",
                    }}
                    onClick={() => navigate("/Register")}
                    type="primary"
                    size="large"
                    hasTitle={true}
                  >
                    عضویت در پلتفرم
                  </CustomButton>
                </Row>
                <Row
                  className="iran"
                  style={{
                    marginTop: "40px",
                  }}
                >
                  <Card
                    style={{ height: "551px", width: "319px", margin: "auto" }}
                  >
                    <Col
                      style={{
                        width: "560px",
                        height: "610px",
                        display: state === 0 ? "block" : "none",
                      }}
                    >
                      <Row
                        style={{
                          height: "42px",
                          textAlign: "center",
                          marginTop: "29.5px",
                        }}
                      >
                        <Typography.Text
                          className="iran"
                          style={{ fontSize: "24px", fontWeight: 600 }}
                        >
                          ورود
                        </Typography.Text>
                      </Row>
                      <Row style={{ marginTop: "32px" }}>
                        <CustomLabel
                          style={{ fontSize: "16px", fontWeight: "325" }}
                          customSize="XLarge"
                        >
                          لطفا شماره موبایل خود را وارد کنید
                        </CustomLabel>
                      </Row>
                      <Row style={{ fontFamily: "YekanBakhVF" }}>
                        <InputWithIcons
                          size="xlarge"
                          value={getPhoneNumber}
                          onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                      </Row>
                      <Row style={{ marginTop: "12px" }}>
                        <div
                          style={{
                            display: getPhoneNumberIsNotEmpty
                              ? "none"
                              : "block",
                          }}
                        >
                          <HintInput customSize="Large" status="Error">
                            لطفا این قسمت را خالی نگذارید
                          </HintInput>
                        </div>
                        <div
                          style={{
                            display: getPhoneNumberIsValid ? "none" : "block",
                          }}
                        >
                          <HintInput customSize="Large" status="Error">
                            شماره موبایل نادرست است
                          </HintInput>
                        </div>
                      </Row>
                      <Row style={{ marginTop: "24px" }}>
                        <CustomLabel
                          style={{ fontSize: "16px", fontWeight: "325" }}
                          customSize="XLarge"
                        >
                          لطفا رمز عبور خود را وارد کنید{" "}
                        </CustomLabel>
                      </Row>
                      <Row style={{ fontFamily: "YekanBakhVF" }}>
                        <InputWithIcons
                          size="xlarge"
                          type="password"
                          value={getPassword}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </Row>
                      <Row style={{ marginTop: "12px" }}>
                        <div
                          style={{
                            display: getPasswordIsValid ? "none" : "block",
                          }}
                        >
                          <HintInput customSize="Large" status="Error">
                            رمز عبور نادرست است
                          </HintInput>
                        </div>
                      </Row>
                      <Row style={{ marginTop: "36px" }}>
                        <CustomButton
                          onClick={() => {
                            loginUser();
                          }}
                          disabled={false}
                          customSize="Large"
                          type="primary"
                          hasTitle={true}
                          style={{ width: "100%" }}
                        >
                          تایید
                        </CustomButton>
                      </Row>
                      <Row
                        className="iran"
                        style={{
                          marginTop: "21.5px",
                          height: "40px",
                          textAlign: "center",
                        }}
                      >
                        <CustomButton
                          style={{ width: "100%" }}
                          type="link"
                          size="large"
                          hasTitle={true}
                          onClick={() => sendForgetCode()}
                        >
                          فراموشی رمز عبور{" "}
                        </CustomButton>
                      </Row>
                    </Col>
                  </Card>
                </Row>
              </Col>
              <Col style={{ display: state === 1 ? "block" : "none" }}>
                <Row
                  className="iran"
                  style={{
                    marginTop: "40px",
                  }}
                >
                  <Card
                    style={{ height: "551px", width: "319px", margin: "auto" }}
                  >
                    <Col>
                      <Row
                        style={{
                          height: "42px",
                          textAlign: "right",
                          marginTop: "29.5px",
                        }}
                      >
                        <div onClick={() => setState(0)}>
                          <TedIcon Icon={ArrowRightOutlined} />
                        </div>
                        <TedTitle customSize="XLarge" text="ارسال کد" />
                      </Row>
                      <Row style={{ marginTop: "32px" }}>
                        <CustomLabel
                          style={{ fontSize: "16px", fontWeight: "325" }}
                          customSize="XLarge"
                        >
                          لطفا کد ارسال شده به شماره موبایل{" "}
                          {convertToPersianDigits(getPhoneNumber)} را وارد کنید{" "}
                        </CustomLabel>
                      </Row>
                      <Row style={{ fontFamily: "YekanBakhVF" }}>
                        <TedOTP length={5} onChange={handleOtpChange} />
                      </Row>
                      <Row style={{ marginTop: "24px" }}>
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <CustomButton
                            LeftIconEnabled
                            LeftIcon={LoadingOutlined}
                            hasTitle
                            customType="Text"
                          >
                            ارسال مجدد کد تا {formattedTime}
                          </CustomButton>
                        </div>
                      </Row>

                      <Row style={{ marginTop: "36px" }}>
                        <CustomButton
                          onClick={() => {
                            CheckConfirmAsync();
                          }}
                          disabled={false}
                          customSize="Large"
                          type="primary"
                          hasTitle={true}
                          style={{ width: "100%" }}
                        >
                          تایید
                        </CustomButton>
                      </Row>
                    </Col>
                  </Card>
                </Row>
              </Col>
              <Col style={{ display: state === 2 ? "block" : "none" }}>
                <Row
                  className="iran"
                  style={{
                    marginTop: "40px",
                  }}
                >
                  <Card
                    style={{ height: "551px", width: "319px", margin: "auto" }}
                  >
                    <Col
                      style={{
                        width: "560px",
                        height: "610px",
                      }}
                    >
                      <Row
                        style={{
                          height: "42px",
                          textAlign: "center",
                          marginTop: "29.5px",
                        }}
                      >
                        <Typography.Text
                          className="iran"
                          style={{ fontSize: "24px", fontWeight: 600 }}
                        >
                          وارد کردن رمز جدید
                        </Typography.Text>
                      </Row>
                      <Row style={{ marginTop: "32px" }}>
                        <CustomLabel
                          style={{ fontSize: "16px", fontWeight: "325" }}
                          customSize="XLarge"
                        >
                          لطفا رمز عبور جدید را وارد کنید
                        </CustomLabel>
                      </Row>
                      <Row style={{ fontFamily: "YekanBakhVF" }}>
                        <InputWithIcons
                          size="xlarge"
                          type="password"
                          value={getPassword4get}
                          onChange={(e) => setPassword4get(e.target.value)}
                        />
                      </Row>
                      <Row style={{ marginTop: "12px" }}>
                        <div
                          style={{
                            display: true ? "none" : "block",
                          }}
                        >
                          <HintInput customSize="Large" status="Error">
                            لطفا این قسمت را خالی نگذارید
                          </HintInput>
                        </div>
                      </Row>
                      <Row style={{ marginTop: "24px" }}>
                        <CustomLabel
                          style={{ fontSize: "16px", fontWeight: "325" }}
                          customSize="XLarge"
                        >
                          لطفا رمز عبور را مجدد وارد کنید
                        </CustomLabel>
                      </Row>
                      <Row style={{ fontFamily: "YekanBakhVF" }}>
                        <InputWithIcons
                          size="xlarge"
                          type="password"
                          value={getRepeatPassword}
                          onChange={(e) => setRepeatPassword(e.target.value)}
                        />
                      </Row>

                      <Row style={{ marginTop: "36px" }}>
                        <CustomButton
                          onClick={() => {
                            ChangePasswordApi({
                              currentPassword: "",
                              phoneNumber: getPhoneNumber,
                              password: getPassword4get,
                              passwordConfirm: getRepeatPassword,
                            }).then(() => navigate("/"));
                          }}
                          disabled={false}
                          customSize="Large"
                          type="primary"
                          hasTitle={true}
                          style={{ width: "100%" }}
                        >
                          تایید
                        </CustomButton>
                      </Row>
                      <Row
                        className="iran"
                        style={{
                          marginTop: "21.5px",
                          height: "40px",
                          textAlign: "center",
                        }}
                      ></Row>
                    </Col>
                  </Card>
                </Row>
              </Col>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default LoginV2;
